<template lang="pug">
.basketPageComponent
  ui-observer(@observe="observeHeaderWrapper")
    .headerWrapper
      .leaveBasket(@click="back")
        ui-svg-icon(name="arrow-left" :size="13")
        .text Вернуться назад
      .pageTitle Корзина

  .container
    .content
      .basket
        template(v-if="isLoading")
          .loader
            ui-loader(:is-responsive="true")
        template(v-else-if="itemsCount")
          basket-items
          ui-observer(@observe="observeBasketPay")
            basket-pay(:class="{'fixed': basketPayClass}")
            a(name="basketPay")
        template(v-else) Корзина пуста
      //- basket-special-offers
      basket-sticky(
        :class="{'visible': !basketPayIsVisible}"
        @onButtonClick="scrollToPay"
      )
</template>

<script>
import BasketItems from '@/modules/Basket/components/BasketItems'
import BasketPay from '@/modules/Basket/components/BasketPay'
import BasketSpecialOffers from '@/modules/Basket/components/BasketSpecialOffers'
import BasketSticky from '@/modules/Basket/components/BasketSticky.vue'
import BasketLeaveModal from '@/modules/Basket/components/BasketLeaveModal.vue'
import { ref, computed, inject, onMounted, onUnmounted } from 'vue'
import { useRouter, onBeforeRouteLeave } from 'vue-router'

export default {
  components: { BasketItems, BasketPay, BasketSpecialOffers, BasketSticky, BasketLeaveModal },
  setup () {
    const store = inject('store')

    const router = useRouter()
    const back = () => {
      if (router.options.history.state.back) router.push(router.options.history.state.back)
      else router.push({ name: 'Catalog' })
    }
    const isBasketLeaveConfirm = ref(false)
    onBeforeRouteLeave((to) => {
      if (itemsCount.value && !isBasketLeaveConfirm.value) {
        store.modalQueue.push({
          key: 'basketLeave',
          component: BasketLeaveModal,
          props: { to },
          on: {
            confirm: (to) => {
              isBasketLeaveConfirm.value = true
              router.push(to)
            }
          }
        })
        return false
      } else return true
    })

    const itemsCount = computed(() => store.basket.data?.itemsCount)
    const isLoading = computed(() => store.basket.isLoading)

    const basketPayIsVisible = ref()
    const observeBasketPay = (event) => (basketPayIsVisible.value = event)

    const WW = ref()
    const headerWrapperIsVisible = ref()
    const observeHeaderWrapper = (event) => (headerWrapperIsVisible.value = event)
    const basketPayClass = computed(() => {
      if (WW.value > 610 && !headerWrapperIsVisible.value) return true
      else return false
    })
    const setWW = () => (WW.value = window.innerWidth)
    onMounted(() => {
      WW.value = window.innerWidth
      window.addEventListener('resize', setWW)
    })
    onUnmounted(() => window.removeEventListener('resize', setWW))

    const scrollToPay = () => (window.location.href = '#basketPay')
    return { itemsCount, isLoading, observeBasketPay, observeHeaderWrapper, basketPayIsVisible, basketPayClass, scrollToPay, back }
  }
}
</script>

<style lang="sass" scoped>
.basketPageComponent
  .headerWrapper
    width: 100%
    display: grid
    grid-template-columns: 1fr
    gap: 6*$u
    margin-bottom: 10*$u

    > .pageTitle
      @include font('h1')
    .leaveBasket
      display: flex
      align-items: center
      color: $cBlue
      cursor: pointer
      .text
        margin-left: $u
        font-size: 12px
        line-height: 4*$u
  > .container
    display: flex
    flex-direction: row
    @include gap2d(7.5*$u)
    > .content
      flex: 1
      .basket
        width: 100%
        display: flex
        gap: 7.5*$u
        justify-content: space-between
        margin-bottom: 7*$u
        @media (max-width: $appMaxWidth)
          max-width: calc(100vw - #{18*$u})
        @media (max-width: $XLWidth)
          gap: 5*$u
        @media (max-width: $padWidth)
          max-width: calc(100vw - #{10*$u})
        @media (max-width: $XSWidth)
          flex-direction: column
        .loader
          width: 10*$u
          height: 10*$u
          margin: 10*$u auto

  @media (max-width: $padWidth)
    > .headerWrapper
      row-gap: 6*$u
      margin-bottom: 7*$u

      > .pageTitle
        @include font('m-h1')

    > .container
      @include gap2d(0px)
      margin-left: 0
</style>
